import { useI18n } from "../i18n/LocaleContext";

const qaItems = [
  "Desktop 16:9 layout keeps the Sound DNA panel visible.",
  "Tablet layout preserves the central performance surface.",
  "Mobile portrait and landscape layouts avoid horizontal scroll.",
  "Every major command has an aria-label and a visible focus state.",
  "Touch targets stay at or above 44px.",
  "Audio activation happens after a direct user gesture.",
  "Instrument, variant, and tuning selectors remain keyboard reachable.",
  "Cultural context warnings can be dismissed without losing instrument metadata."
];

export function QAPage() {
  const { t } = useI18n();

  return (
    <section className="content-page narrow" aria-labelledby="qa-title">
      <div className="content-page-heading">
        <p className="eyebrow">{t.pages.qaEyebrow}</p>
        <h1 id="qa-title">{t.pages.qaTitle}</h1>
      </div>
      <ul className="qa-list">
        {qaItems.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </section>
  );
}
